"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ConfirmModal", {
    enumerable: true,
    get: function() {
        return ConfirmModal;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _react1 = require("@headlessui/react");
var _loadingBar = require("../LoadingBar");
var _modal = require("./Modal");
var _button = require("../Button");
var _divider = require("../Divider");
var _exclamationCircleIcon = /*#__PURE__*/ _interopRequireDefault(require("@heroicons/react/outline/ExclamationCircleIcon"));
var _exclamationIcon = /*#__PURE__*/ _interopRequireDefault(require("@heroicons/react/outline/ExclamationIcon"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ConfirmModal = function(param) {
    var _param_maxWidth = param.maxWidth, maxWidth = _param_maxWidth === void 0 ? "lg" : _param_maxWidth, show = param.show, onConfirm = param.onConfirm, onCancel = param.onCancel, title = param.title, message = param.message, _param_cancelLabel = param.cancelLabel, cancelLabel = _param_cancelLabel === void 0 ? "Cancel" : _param_cancelLabel, confirmLabel = param.confirmLabel, footer = param.footer, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_isForm = param.isForm, isForm = _param_isForm === void 0 ? false : _param_isForm, _param_isWarning = param.isWarning, isWarning = _param_isWarning === void 0 ? false : _param_isWarning;
    var renderModalContent = function() {
        return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
            className: "sm:flex sm:items-start"
        }, /*#__PURE__*/ _react.default.createElement("div", {
            className: (0, _classnames.default)("mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full  sm:mx-0 sm:h-10 sm:w-10", {
                "bg-red-100": !isWarning,
                "bg-yellow-100": isWarning
            })
        }, !isWarning ? /*#__PURE__*/ _react.default.createElement(_exclamationCircleIcon.default, {
            className: "h-6 w-6 text-red-600",
            "aria-hidden": "true"
        }) : /*#__PURE__*/ _react.default.createElement(_exclamationIcon.default, {
            className: "h-6 w-6 text-yellow-600",
            "aria-hidden": "true"
        })), /*#__PURE__*/ _react.default.createElement("div", {
            className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
        }, /*#__PURE__*/ _react.default.createElement(_react1.Dialog.Title, {
            as: "h3",
            className: "text-lg leading-6 font-medium text-gray-900"
        }, title), /*#__PURE__*/ _react.default.createElement("div", {
            className: "mt-2"
        }, /*#__PURE__*/ _react.default.createElement("p", {
            className: "text-sm text-gray-500"
        }, message)), footer && /*#__PURE__*/ _react.default.createElement("div", {
            className: "mt-2"
        }, footer), /*#__PURE__*/ _react.default.createElement(_divider.Divider, {
            className: "w-full my-4",
            text: ""
        }), /*#__PURE__*/ _react.default.createElement("div", {
            className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"
        }, isForm ? /*#__PURE__*/ _react.default.createElement(_button.ButtonPrimary, {
            type: "submit",
            color: "red",
            className: "sm:ml-3 sm:w-auto sm:text-sm",
            "data-testid": "confirm-modal-confirm-btn",
            disabled: loading
        }, /*#__PURE__*/ _react.default.createElement("div", {
            className: "flex items-center"
        }, loading && /*#__PURE__*/ _react.default.createElement(_loadingBar.LoadingBar, {
            size: "sm",
            color: "white",
            className: "mr-2"
        }), /*#__PURE__*/ _react.default.createElement("span", null, confirmLabel))) : /*#__PURE__*/ _react.default.createElement(_button.ButtonPrimary, {
            type: "button",
            color: !isWarning ? "red" : undefined,
            className: "sm:ml-3 sm:w-auto sm:text-sm",
            "data-testid": "confirm-modal-confirm-btn",
            disabled: loading,
            onClick: function() {
                return onConfirm();
            }
        }, /*#__PURE__*/ _react.default.createElement("div", {
            className: "flex items-center"
        }, loading && /*#__PURE__*/ _react.default.createElement(_loadingBar.LoadingBar, {
            size: "sm",
            color: "white",
            className: "mr-2"
        }), /*#__PURE__*/ _react.default.createElement("span", null, confirmLabel))), /*#__PURE__*/ _react.default.createElement(_button.ButtonDefault, {
            disabled: loading,
            type: "button",
            className: "mt-3 sm:mt-0 sm:w-auto sm:text-sm",
            "data-testid": "confirm-modal-cancel-btn",
            onClick: function() {
                return onCancel();
            }
        }, cancelLabel)))));
    };
    return /*#__PURE__*/ _react.default.createElement(_modal.Modal, {
        show: show,
        onClose: function() {
            return !loading && onCancel();
        },
        maxWidth: maxWidth,
        loading: loading
    }, isForm ? /*#__PURE__*/ _react.default.createElement("form", {
        onSubmit: onConfirm
    }, renderModalContent()) : /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, renderModalContent()));
};

//# sourceMappingURL=ConfirmModal.js.map